import { isError, isNetworkError } from '@allurion/utils';
import { Auth } from 'aws-amplify';

import { Logger } from 'src/services/Logger';

export async function getUserSession() {
  try {
    return await Auth.currentSession();
  } catch (ex: unknown) {
    const message = isError(ex) ? ex.message : ex;

    const shouldLogException =
      message !== 'No current user' && message !== 'Refresh Token has expired';

    if (shouldLogException) {
      // A refresh that never reached Cognito is the user's connection, not a
      // fault of the application, and `Auth.currentSession()` runs on every
      // request through `getUserSessionToken`. Reported at `warning` under its
      // own fingerprint rather than dropped, because the same rejection is what
      // a CORS or CSP regression against the Cognito endpoint would produce --
      // see `isNetworkError`. INSIGHTS-UI-K9 collects them: 6,163 events since
      // 2024-03, spread thin across users, countries, browsers and releases
      // rather than arriving in the burst an outage would make -- the issue's
      // tag breakdown is where to re-read that. It groups on the
      // `amazon-cognito-identity-js` frame, which `LoginPage`'s `Auth.signIn`
      // failures reach too, so this call site is a share of the issue rather
      // than the whole of it.
      Logger.captureException(
        ex,
        isNetworkError(ex)
          ? { level: 'warning', fingerprint: ['cognito-session-refresh-unreachable'] }
          : undefined
      );
    } else if (isError(ex)) {
      // eslint-disable-next-line no-console
      console.log('getUserSession', ex.message);
    }

    return null;
  }
}

export async function getUserSessionToken() {
  const userSession = await getUserSession();

  return userSession?.getIdToken().getJwtToken();
}
